/**
 * Gefilterte Vorschlags-Query je Review-Queue-Tab (route/status/page).
 *
 * Kein `keepPreviousData`: das etablierte Paginierungs-Muster im Repo
 * (`useProductsListQuery.ts`, Admin-Listen) verzichtet ebenfalls darauf —
 * `keepPreviousData` wird hier nur für Live-Preview-Werte genutzt
 * (`usePricingPreview.ts`), nicht für Seiten-Listen.
 */

import { useQuery } from '@tanstack/react-query'

import { listSuggestions } from '@/lib/api/channel-content-bulk'

import { textRunKeys, type SuggestionFilters } from './runStatus'

export function useSuggestions(filters: SuggestionFilters) {
  return useQuery({
    queryKey: textRunKeys.suggestions(filters),
    queryFn: () => listSuggestions(filters),
  })
}
